(function () {
  if (window.ProductGallery?.lifecycleVersion) {
    window.ProductGallery.init(document);
    return;
  }

  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.mainImages = Array.from(container.querySelectorAll(".shop-main-image"));
      this.zoomWrappers = Array.from(container.querySelectorAll(".shop-image-zoom-wrapper"));
      this.thumbnails = Array.from(container.querySelectorAll(".shop-thumbnail"));
      this.dots = Array.from(container.querySelectorAll(".shop-dot"));
      this.desktopPrevArrow = container.querySelector(".shop-desktop-prev-arrow");
      this.desktopNextArrow = container.querySelector(".shop-desktop-next-arrow");
      this.mobilePrevArrows = Array.from(container.querySelectorAll(".shop-mobile-prev-arrow"));
      this.mobileNextArrows = Array.from(container.querySelectorAll(".shop-mobile-next-arrow"));
      this.imageContainer = container.querySelector(".shop-image-container");
      this.isMobilePeek = container.classList.contains("shop-mobile-peek-gallery");
      this.mobilePeekSlides = this.imageContainer
        ? Array.from(this.imageContainer.children).filter(
            (slide) => slide.classList.contains("shop-image-zoom-wrapper") || slide.classList.contains("shop-main-image"),
          )
        : [];
      this.progressBar = container.querySelector(".shop-gallery-progress span");
      this.enableAutoplay = container.dataset.autoplay === "true";
      this.scrollRaf = null;
      this.currentIndex = 0;
      this.maxIndex = this.mainImages.length - 1;
      this.init();
    }
    init() {
      this.loadImage(0);
      if (this.isMobilePeek && this.maxIndex >= 1) this.loadImage(1);
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === 0);
      });
      const activeWrapper = this.mainImages[0]?.closest(".shop-image-zoom-wrapper");
      this.zoomWrappers.forEach((wrapper) => {
        wrapper.classList.toggle("active", wrapper === activeWrapper);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === 0);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === 0);
      });
      if (this.isMobilePeek) this.updateProgress(0);
      this.attachEvents();
      this.initZoom();
      this.handleVideoAutoplay(0);
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.isSwiping = !1;
      this.isPinching = !1;
      this.swipeDetectionTimer = null;
      this.swipeThreshold = 30;
      this.swipeDirectionRatio = 1.15;
      if (this.isMobilePeek) {
        this.setupMobilePeek();
      } else {
        const imageContainer = this.container.querySelector(".shop-main-image-wrapper");
        if (imageContainer) {
        imageContainer.addEventListener(
          "touchstart",
          (e) => {
            // Clear any pending swipe detection
            if (this.swipeDetectionTimer) {
              clearTimeout(this.swipeDetectionTimer);
              this.swipeDetectionTimer = null;
            }

            // Immediate pinch detection (2+ fingers)
            if (e.touches.length >= 2) {
              this.isPinching = !0;
              this.isSwiping = !1;
              return;
            }

            // Single finger swipe starts immediately. Fast real swipes can end before a timer fires.
            this.touchStartX = e.changedTouches[0].screenX;
            this.touchStartY = e.changedTouches[0].screenY;
            this.touchEndX = this.touchStartX;
            this.touchEndY = this.touchStartY;
            this.isPinching = !1;
            this.isSwiping = !0;
          },
          { passive: !0 },
        );
        imageContainer.addEventListener(
          "touchmove",
          (e) => {
            // Ignore pinch; when movement is mostly horizontal, keep the page from swallowing the swipe.
            if (this.isPinching || !this.isSwiping) return;
            const currentX = e.changedTouches[0].screenX;
            const currentY = e.changedTouches[0].screenY;
            this.touchEndX = currentX;
            this.touchEndY = currentY;
            const deltaX = currentX - this.touchStartX;
            const deltaY = currentY - this.touchStartY;
            if (Math.abs(deltaX) > this.swipeThreshold / 2 && Math.abs(deltaX) > Math.abs(deltaY) * this.swipeDirectionRatio) {
              e.preventDefault();
            }
          },
          { passive: !1 },
        );
        imageContainer.addEventListener(
          "touchend",
          (e) => {
            // Clear any pending swipe detection timer
            if (this.swipeDetectionTimer) {
              clearTimeout(this.swipeDetectionTimer);
              this.swipeDetectionTimer = null;
            }

            // Don't trigger swipe if it was a pinch gesture.
            if (!this.isPinching && this.isSwiping) {
              this.touchEndX = e.changedTouches[0].screenX;
              this.touchEndY = e.changedTouches[0].screenY;
              this.handleSwipeGesture();
            }
            this.isSwiping = !1;
            this.isPinching = !1;
          },
          { passive: !0 },
        );
        }
      }
    }
    attachEvents() {
      this.thumbnails.forEach((thumb, i) => {
        thumb.addEventListener("click", () => this.changeImage(i));
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", () => this.changeImage(i));
      });
      if (this.desktopPrevArrow) {
        this.desktopPrevArrow.addEventListener("click", () => {
          const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
          this.changeImage(newIndex);
        });
      }
      if (this.desktopNextArrow) {
        this.desktopNextArrow.addEventListener("click", () => {
          const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
          this.changeImage(newIndex);
        });
      }
      this.mobilePrevArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => {
            const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
            this.changeImage(newIndex);
          });
        }
      });
      this.mobileNextArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => {
            const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
            this.changeImage(newIndex);
          });
        }
      });
    }
    setupMobilePeek() {
      if (!this.imageContainer || !this.mobilePeekSlides.length) return;
      this.imageContainer.addEventListener(
        "scroll",
        () => {
          if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
          this.scrollRaf = requestAnimationFrame(() => {
            this.scrollRaf = null;
            this.syncMobilePeekFromScroll();
          });
        },
        { passive: !0 },
      );
      this.onResize = () => this.updateProgress(this.currentIndex);
      window.addEventListener("resize", this.onResize, { passive: !0 });
    }
    initZoom() {
      this.zoomWrappers.forEach((wrapper) => {
        if (!wrapper.classList.contains("image-zoom-enabled") || wrapper.__zoomInitialized) return;
        const image = wrapper.querySelector(".shop-main-image");
        const overlay = wrapper.querySelector(".image-zoom-overlay");
        if (!image || !overlay) return;
        wrapper.__zoomInitialized = true;
        wrapper.addEventListener("mousemove", (event) => {
          const rect = wrapper.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          overlay.style.backgroundImage = `url("${image.dataset.zoomSrc || image.currentSrc || image.src}")`;
          overlay.style.backgroundPosition = `${x}% ${y}%`;
        });
        wrapper.addEventListener("mouseleave", () => {
          overlay.style.backgroundPosition = "center";
        });
      });
    }
    dispose() {
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      if (this.onResize) window.removeEventListener("resize", this.onResize);
      this.container.querySelectorAll("olvaxin-lazy-video").forEach((video) => video.removeAttribute("data-active"));
      delete this.container.__galleryInstance;
    }
    getMobilePeekIndex() {
      if (!this.imageContainer || !this.mobilePeekSlides.length) return this.currentIndex;
      const currentLeft = this.imageContainer.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      this.mobilePeekSlides.forEach((slide, i) => {
        const slideLeft = slide.offsetLeft - this.imageContainer.offsetLeft;
        const distance = Math.abs(slideLeft - currentLeft);
        if (distance < closestDistance) {
          closestIndex = i;
          closestDistance = distance;
        }
      });
      return closestIndex;
    }
    syncMobilePeekFromScroll() {
      const index = this.getMobilePeekIndex();
      const maxScroll = this.imageContainer ? this.imageContainer.scrollWidth - this.imageContainer.clientWidth : 0;
      const ratio = maxScroll > 0 ? this.imageContainer.scrollLeft / maxScroll : 0;
      if (index !== this.currentIndex) {
        this.applyActiveIndex(index, { skipThumbnailScroll: !0, progressRatio: ratio });
      } else {
        this.updateProgress(index, ratio);
      }
    }
    scrollMobilePeekToIndex(index) {
      if (!this.imageContainer || !this.mobilePeekSlides[index]) return;
      const targetLeft = this.mobilePeekSlides[index].offsetLeft - this.imageContainer.offsetLeft;
      this.imageContainer.scrollTo({ left: targetLeft, behavior: "smooth" });
    }
    updateProgress(index, ratio) {
      if (!this.progressBar) return;
      const total = this.maxIndex + 1;
      if (total <= 1) return;
      const segmentWidth = 100 / total;
      const safeRatio =
        typeof ratio === "number" && Number.isFinite(ratio)
          ? Math.max(0, Math.min(1, ratio))
          : this.maxIndex > 0
            ? index / this.maxIndex
            : 0;
      this.progressBar.style.width = `${segmentWidth}%`;
      this.progressBar.style.transform = `translateX(${safeRatio * (total - 1) * 100}%)`;
    }
    loadImage(index) {
      const img = this.mainImages[index];
      if (!img || img.tagName !== "IMG") return;
      const picture = img.closest("picture");
      if (picture) {
        picture.querySelectorAll("source[data-srcset]").forEach((source) => {
          const sourceSrcset = source.getAttribute("data-srcset");
          const sourceSizes = source.getAttribute("data-sizes");
          if (sourceSrcset && source.getAttribute("srcset") !== sourceSrcset) {
            source.setAttribute("srcset", sourceSrcset);
          }
          if (sourceSizes && source.getAttribute("sizes") !== sourceSizes) {
            source.setAttribute("sizes", sourceSizes);
          }
        });
      }
      const src = img.getAttribute("data-src");
      const srcset = img.getAttribute("data-srcset");
      const sizes = img.getAttribute("data-sizes");
      if (sizes && img.getAttribute("sizes") !== sizes) {
        img.setAttribute("sizes", sizes);
      }
      if (srcset && img.getAttribute("srcset") !== srcset) {
        img.setAttribute("srcset", srcset);
      }
      if (src && img.getAttribute("src") !== src) {
        img.setAttribute("src", src);
      }
    }
    applyActiveIndex(index, options = {}) {
      if (index < 0 || index > this.maxIndex) return;
      this.loadImage(index);
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === index);
      });
      const activeWrapper = this.mainImages[index].closest(".shop-image-zoom-wrapper");
      this.zoomWrappers.forEach((wrapper) => {
        wrapper.classList.toggle("active", wrapper === activeWrapper);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === index);
        thumb.setAttribute("aria-current", String(i === index));
        thumb.setAttribute("aria-pressed", String(i === index));
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
        dot.setAttribute("aria-current", String(i === index));
        dot.setAttribute("aria-pressed", String(i === index));
      });
      this.currentIndex = index;
      if (!options.skipThumbnailScroll && !this.isMobilePeek) {
        this.scrollToThumbnail(index);
      }
      if (this.isMobilePeek) {
        this.updateProgress(index, options.progressRatio);
      }
      this.handleVideoAutoplay(index);
    }
    changeImage(index) {
      if (index < 0 || index > this.maxIndex) return;
      this.applyActiveIndex(index);
      if (this.isMobilePeek) {
        this.scrollMobilePeekToIndex(index);
      }
    }
    scrollToThumbnail(index) {
      if (!this.thumbnails[index]) return;
      const thumbnail = this.thumbnails[index];
      const container = thumbnail.parentElement;
      if (!container) return;
      const containerWidth = container.offsetWidth;
      const thumbnailWidth = thumbnail.offsetWidth;
      const thumbnailLeft = thumbnail.offsetLeft;
      const scrollPosition = thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;
      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
    handleSwipeGesture() {
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      if (Math.abs(deltaX) > this.swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY) * this.swipeDirectionRatio) {
        const numImages = this.mainImages.length;
        const currentImageIndex = this.currentIndex;
        const nextIndex = (currentImageIndex + 1) % numImages;
        const prevIndex = (currentImageIndex - 1 + numImages) % numImages;
        if (deltaX < 0) {
          this.changeImage(nextIndex);
        } else {
          this.changeImage(prevIndex);
        }
      }
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
    }
    handleVideoAutoplay(index) {
      // Pause all videos first
      this.mainImages.forEach((img, i) => {
        const lazyVideo = img.querySelector("olvaxin-lazy-video");
        if (lazyVideo) {
          lazyVideo.toggleAttribute("data-active", i === index);
          return;
        }
        const video = img.querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        // Pause external videos (YouTube/Vimeo)
        const iframe = img.querySelector("iframe");
        if (iframe) {
          const src = iframe.src;
          if (src.includes("youtube.com")) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
        }
      });
      
      // Play the active video if autoplay is enabled
      const activeMedia = this.mainImages[index];
      if (!activeMedia || activeMedia.querySelector("olvaxin-lazy-video")) return;
      
      if (this.enableAutoplay) {
        // Handle local videos
        const videoToPlay = activeMedia.querySelector("video");
        if (videoToPlay) {
          videoToPlay.play().catch(() => {});
        }
        
        // Handle external videos (YouTube/Vimeo)
        const iframeToPlay = activeMedia.querySelector("iframe");
        if (iframeToPlay) {
          const src = iframeToPlay.src;
          if (src.includes("youtube.com")) {
            iframeToPlay.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframeToPlay.contentWindow.postMessage('{"method":"play"}', "*");
          }
        }
      }
    }
    updateWithVariant(variant) {
      let matchIndex = -1;
      if (variant && (variant.mediaId || variant.variantId || variant.imageUrl)) {
        this.mainImages.forEach((img, i) => {
          if (
            (variant.mediaId && img.dataset.mediaId == variant.mediaId) ||
            (variant.variantId && img.dataset.variantId == variant.variantId) ||
            (variant.imageUrl &&
              ((img.src || "").includes(variant.imageUrl) || (img.dataset.src && img.dataset.src.includes(variant.imageUrl))))
          ) {
            matchIndex = i;
          }
        });
      }
      if (matchIndex >= 0) {
        this.changeImage(matchIndex);
      }
    }
  }
  const galleryRegistry = [];
  const sectionSelector = ".shop-product-section, .featured-product-section, [data-section-id]";
  const sectionRoot = (element) => element.closest(sectionSelector) || element;
  function initAll(root = document) {
    const containers = root.matches?.(".product-gallery") ? [root] : root.querySelectorAll(".product-gallery");
    containers.forEach((container) => {
      if (!container.__galleryInstance) {
        const gallery = new ProductGallery(container);
        container.__galleryInstance = gallery;
        galleryRegistry.push(gallery);
      }
    });
  }
  function updateScopedGalleries(event) {
    const detail = event.detail;
    if (!detail?.scope || !(detail.variantId || detail.mediaId || detail.imageUrl)) return;
    galleryRegistry.forEach((gallery) => {
      if (sectionRoot(gallery.container) === detail.scope) gallery.updateWithVariant(detail);
    });
  }
  document.addEventListener("variantChanged", updateScopedGalleries);
  document.addEventListener("variantImageSelected", updateScopedGalleries);
  document.addEventListener("variant:imageChanged", updateScopedGalleries);
  function disposeAll(root) {
    for (let index = galleryRegistry.length - 1; index >= 0; index -= 1) {
      const gallery = galleryRegistry[index];
      if (root === gallery.container || root.contains?.(gallery.container)) {
        gallery.dispose();
        galleryRegistry.splice(index, 1);
      }
    }
  }
  window.ProductGallery = { lifecycleVersion: 1, init: initAll, dispose: disposeAll, getAll: () => galleryRegistry };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => disposeAll(event.target));
})();
